<ng-container class="ms-2 me-2">
    <div class="butonera">
        <select [(ngModel)]="selectedTrimester" (selectionChange)="setTrimester()" class="form-select me-1">
            <option value=0>Seleccionar trimestre</option>
            <option value=1>Primer trimestre</option>
            <option value=2>Segundo trimestre</option>
            <option value=3>Tercer trimestre</option>
            <option value=4>Cuatro trimestre</option>
        </select>
        <select [(ngModel)]="selectedModel" (selectionChange)="setModel()" class="form-select me-1">
            <option value=0>Seleccionar modelo</option>
            <option value=111>Modelo 111</option>
            <option value=115>Modelo 115</option>
            <option value=130>Modelo 130</option>
            <option value=131>Modelo 131</option>
        </select>
        <button mat-stroked-button class="ms-2" (click)="generateModel()">Generar modelo</button>
    </div>
</ng-container>

<br />

<br />

<div class="w-100 mt-5 toplineBlue">
    <div class="bg-white">
        <div class="mainBody">
            <ng-container *ngIf="spinner" class="ms-2 me-2">
                <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
            </ng-container>

            <ng-container *ngIf="spinner == false" class="ms-2 me-2">
                <div *ngIf="fiscalModel.model == 130" >
                    <p>
                        <strong>Liquidación - Modelo 130</strong>
                    </p>
                    <hr>

                    <p><strong>I. Actividades económicas en estimación directa, modalidad normal o simplificada, distinta de las agrícolas, ganaderas, forestales y pesqueras.</strong> (Datos acumulados del período comprendido entre el primer día del año y el último día del trimestre)</p>
                    <p>
                        <mat-label>Ingresos computables correspondientes al conjunto de las actividades ejercidas</mat-label>  
                        <span>[01]<input matInput type="number" [(ngModel)]="fiscalModel.field01" readonly></span>
                    </p>
                    <p>
                        <mat-label>Gastos fiscalmente deducibles correspondientes al conjunto de actividades ejercidas</mat-label> 
                        <span>[02]<input matInput type="number" [(ngModel)]="fiscalModel.field02" readonly></span>
                    </p>
                    <p>
                        <mat-label>Rendimiento neto ([01]-[02]). Si se obtiene una cantidad negativa, consígnela con signo menos (-)</mat-label>
                        <span>[03]<input matInput type="number" [(ngModel)]="fiscalModel.field03" readonly></span>
                    </p>
                    <p>
                        <mat-label>20 por 100 del importe positivo de la fiscalModel.field [03], si dicho importe es positivo</mat-label> 
                        <span>[04]<input matInput type="text" [(ngModel)]="fiscalModel.field04" readonly></span>
                    </p>

                    <p><strong>A deducir:</strong></p> 
                    <p>
                        <mat-label>De los trimestres anteriores: suma de los importes positivos de la fiscalModel.field [07] menos la suma de los importes de la fiscalModel.field</mat-label>  
                        <span>[16]<input matInput type="number" [(ngModel)]="fiscalModel.field05"></span>
                        <mat-icon style="color:#3f51b5">refresh</mat-icon>
                    </p>
                    <p>
                        <mat-label>Retenciones e ingresos a cuenta soportados por las actividades incluidas en este apartado y correspondientes al período comprendido entre el primer día del año y el último día del trimestre </mat-label> 
                        <span>[06]<input matInput type="number" [(ngModel)]="fiscalModel.field06" readonly></span>
                    </p>
                    <p>
                        <mat-label>Pago fraccionado previo del trimestre ([04]-[05]-[06])</mat-label> 
                        <span>[07]<input matInput type="number" [(ngModel)]="fiscalModel.field07" readonly></span>
                    </p>

                    <p><strong>II. Actividades agrícolas, ganaderas, forestales y pesqueras en estimación directa, modalidad normal o simplificada</strong></p>                     
                    <p>
                        <mat-label>Volumen de ingresos del trimestre (excluidas las subvenciones de capital y las indemnizaciones)</mat-label>
                        <span>[08]<input matInput type="number" [(ngModel)]="fiscalModel.field07" readonly></span>
                    </p>
                    <p>
                        <mat-label>2 por 100 del importe de la casilla [08] </mat-label>
                        <span>[09]<input matInput type="number" [(ngModel)]="fiscalModel.field07" readonly></span>
                    </p>
                     
                    
                    
                    
                    
                    
                    
                    
                    <!-- por aqui -->
                    
                    
                    
                    <p>
                        <mat-label>Suma de pagos fraccionados previos del trimestre ([07]+[11]). Si se obtiene una cantidad negativa, consigne el número cero (0) [12] </mat-label>
                        <input matInput type="number" [(ngModel)]="fiscalModel.field07" readonly>
                    </p>
                    <p>
                        <mat-label>Diferencia ([12]-[13]). Si se obtiene una cantidad negativa, consígnela con signo menos (-) [14] </mat-label>
                        <input matInput type="number" [(ngModel)]="fiscalModel.field07" readonly>
                    </p>
                    <p>
                        <mat-label>Total ([14]-[15]-[16]) [17] </mat-label>
                        <input matInput type="number" [(ngModel)]="fiscalModel.field07" readonly>
                    </p>
                    <p>
                        <button mat-stroked-button color="primary" (click)="export()">Exportar Modelo 130</button>
                    </p>
                </div>
            </ng-container>
        </div>
    </div>
</div>




<!-- si son muy distintos entre ellos, se crearan fiscalModel130.component.html, fiscalModel131.component.html, etc 
y se mostrara en esta vista, uno u otro por medio de booleans y de sus respectivos selectores -->

<!-- 
<br />
<mat-card class="d-flex justify-content-between click invoiceHeadTable">
    <mat-card-content class="d-flex justify-content-between row index-row text-center">
        <p>
            Recuerde parametrizar su empresa en la sección Mi Cuenta -> Mi Empresa, si aún no lo ha echo, puede acceder
            desde el siguiente
            enlace
            <button mat-stroked-button color="primary" (click)="goTo()">Acceder a Mi Empresa</button>
        </p>

    </mat-card-content>
</mat-card>
<br />
<ng-container *ngIf="userCompanyServiceReady">
    <ng-container *ngIf="userCompany.modelo130">
        <mat-card class="d-flex justify-content-between click invoiceHeadTable">
            <mat-card-content class="d-flex justify-content-between row index-row text-center">
                <select [(ngModel)]="trimester" class="form-select me-1">
                    <option value=0>Seleccione el trimestre</option>
                    <option value=1>Primer Trimestre (1T)</option>
                    <option value=2>Segundo Trimestre (2T)</option>
                    <option value=3>Tercer Trimestre (3T)</option>
                    <option value=3>Cuarto Trimestre (4T)</option>
                </select>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <button mat-stroked-button color="primary" (click)="generate130()">Generar Modelo 130 (Pagos a cuenta
                    del IRPF)</button>
            </mat-card-content>
        </mat-card>
    </ng-container>

    <ng-container *ngIf="userCompany.modelo115">
        <mat-card class="d-flex justify-content-between click invoiceHeadTable">
            <mat-card-content class="d-flex justify-content-between row index-row text-center">
                <select [(ngModel)]="trimester" class="form-select me-1">
                    <option value=0>Seleccione el trimestre</option>
                    <option value=1>Primer Trimestre (1T)</option>
                    <option value=2>Segundo Trimestre (2T)</option>
                    <option value=3>Tercer Trimestre (3T)</option>
                    <option value=3>Cuarto Trimestre (4T)</option>
                </select>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <button mat-stroked-button color="primary" (click)="generate115()">Generar Modelo 115 (Retenciones del
                    alquiler de locales)</button>
            </mat-card-content>
        </mat-card>
    </ng-container>


    <ng-container *ngIf="userCompany.modelo420">
        <mat-card class="d-flex justify-content-between click invoiceHeadTable">
            <mat-card-content class="d-flex justify-content-between row index-row text-center">
                <select [(ngModel)]="trimester" class="form-select me-1">
                    <option value=0>Seleccione el trimestre</option>
                    <option value=1>Primer Trimestre (1T)</option>
                    <option value=2>Segundo Trimestre (2T)</option>
                    <option value=3>Tercer Trimestre (3T)</option>
                    <option value=3>Cuarto Trimestre (4T)</option>
                </select>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <button mat-stroked-button color="primary" (click)="generate420()">Generar Modelo 420 (Declaración
                    IGIC)</button>
            </mat-card-content>
        </mat-card>
    </ng-container>

    <ng-container *ngIf="userCompany.modelo303">
        <mat-card class="d-flex justify-content-between click invoiceHeadTable">
            <mat-card-content class="d-flex justify-content-between row index-row text-center">
                <select [(ngModel)]="trimester" class="form-select me-1">
                    <option value=0>Seleccione el trimestre</option>
                    <option value=1>Primer Trimestre (1T)</option>
                    <option value=2>Segundo Trimestre (2T)</option>
                    <option value=3>Tercer Trimestre (3T)</option>
                    <option value=3>Cuarto Trimestre (4T)</option>
                </select>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <button mat-stroked-button color="primary" (click)="generate303()">Generar Modelo 303 (Declaración
                    IVA)</button>
            </mat-card-content>
        </mat-card>
    </ng-container>

    <ng-container *ngIf="spinner">
        <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
    </ng-container>

    <ng-container *ngIf="ready">
        <mat-card style="width:700px">
            <mat-card-content>
                <p>
                    <strong>Simulación Fichero a exportar</strong>
                </p>
                <hr>
                <p>
                    <mat-label>Ingresos computables correspondientes al conjunto de las actividades ejercidas [01]
                    </mat-label> &nbsp;&nbsp;
                    <input matInput type="number" [(ngModel)]="casilla01" readonly>
                </p>
                <p>
                    <mat-label>Gastos fiscalmente deducibles correspondientes al conjunto de actividades ejercidas [02]
                    </mat-label> &nbsp;&nbsp;
                    <input matInput type="number" [(ngModel)]="casilla02" readonly>
                </p>
                <p>
                    <mat-label>Rendimiento neto ([01]-[02]). Si se obtiene una cantidad negativa, consígnela con signo
                        menos (-) [03]
                    </mat-label> &nbsp; &nbsp;
                    <input matInput type="number" [(ngModel)]="casilla03" readonly>
                </p>
                <p>
                    <mat-label>20 por 100 del importe positivo de la casilla [03], si dicho importe es positivo [04]
                    </mat-label> &nbsp;&nbsp;
                    <input matInput type="text" [(ngModel)]="casilla04" readonly>
                </p>
                <p>
                    <mat-label>De los trimestres anteriores: suma de los importes positivos de la casilla [07] menos la
                        suma de los importes de la casilla [16] </mat-label> &nbsp;&nbsp;
                    <input style="border-bottom: 1px solid red !important;
                    box-shadow: 0 1px 0 0 red !important" matInput type="number" [(ngModel)]="casilla05"
                        (change)="changeTrimester()">
                    <mat-icon style="color:#3f51b5">refresh</mat-icon>
                </p>
                <p>
                    <mat-label>Retenciones e ingresos a cuenta soportados por las actividades incluidas en este apartado
                        y correspondientes al período comprendido entre el primer día del año y el último día del
                        trimestre [06] </mat-label> &nbsp;&nbsp;
                    <input matInput type="number" [(ngModel)]="casilla06" readonly>
                </p>
                <p>
                    <mat-label>Pago fraccionado previo del trimestre ([04]-[05]-[06]) [07] </mat-label> &nbsp;&nbsp;
                    <input matInput type="number" [(ngModel)]="casilla07" readonly>
                </p>
                <p>
                    <mat-label>Suma de pagos fraccionados previos del trimestre ([07]+[11]). Si se obtiene una cantidad
                        negativa, consigne el número cero (0) [12] </mat-label> &nbsp;&nbsp;
                    <input matInput type="number" [(ngModel)]="casilla07" readonly>
                </p>
                <p>
                    <mat-label>Diferencia ([12]-[13]). Si se obtiene una cantidad negativa, consígnela con signo menos
                        (-) [14] </mat-label> &nbsp;&nbsp;
                    <input matInput type="number" [(ngModel)]="casilla07" readonly>
                </p>
                <p>
                    <mat-label>Total ([14]-[15]-[16]) [17] </mat-label> &nbsp;&nbsp;
                    <input matInput type="number" [(ngModel)]="casilla07" readonly>
                </p>
                <p>
                    <button mat-stroked-button color="primary" (click)="export()">Exportar Modelo 130</button>
                </p>
            </mat-card-content>
        </mat-card>
    </ng-container>
</ng-container> -->